import Failmsg from '../../components/failmsg';
function Fail(params) {
  return (
    <>
    <Failmsg/>
</>
  )
}

export default Fail;